import { tradingApiKeysActions } from './slice';
import { listen, createApiKey, updateApiKey, deleteApiKey } from './thunks';

export { listen, createApiKey, updateApiKey, deleteApiKey } from './thunks';
export type { ListenPayload } from './thunks';

export const apiKeysAction = {
  ...tradingApiKeysActions,
  listen,
  createApiKey,
  updateApiKey,
  deleteApiKey,
};
